let initialState = {
	demoRequest: null,
};

const LandingPage = (state = initialState, action) => {
	switch (action.type) {
		case "SET_DEMO_REQUEST":
			return {
				...state,
				demoRequest: action.payload,
			};

		default:
			return state;
	}
};

export default LandingPage;
